export const emptyEditorContentPlainText = 'Brak uwag';